//金额会计化                                 {{scope.row[scope.column.property]|numFilter}}
const numFilter = (num,decimal=2,type=0) => {
    if (num) {
       
        num = num.toString().replace(/\$|\,/g, "");
        num = Number(num)
        num = newFixed(num,decimal)
        if (num === 0&&type==1) {
            return '0.00'
        }else  if (num === 0) {
            return 0
        } else if (num) {

            if (num === "" || isNaN(num)) {
                return 0;
            }
            var sign = "";
            if (num.indexOf("-") !== -1) {
                sign = "-";
                num = num.substr(1);
            }
            var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
            cents = cents.length > 1 ? cents : "";
            num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
            if (cents === "") {
                if (num.length > 1 && num.substr(0, 1) === "0") {
                    return 0;
                }
            } else {
                if (num.length > 1 && num.substr(0, 1) === "0") {
                    return 0;
                }
            }

            for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                num =
                    num.substring(0, num.length - (4 * i + 3)) +
                    "," +
                    num.substring(num.length - (4 * i + 3));
            }
            return sign + num + cents;
        }

    }else{
        return 0
    }

}

//计算两个数的乘积
const accMul = (arg1, arg2) => {
    var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
    if (undefined != s1.split(".")[1]) {
        m += s1.split(".")[1].length;
    }
    if (undefined != s2.split(".")[1]) {
        m += s2.split(".")[1].length;
    }
    return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
    );
}
//保留两位小数
const newFixed=(num, len)=> {
    if(Object.is(parseFloat(num), NaN)) {
      return console.log("非数字");
    }
    let sign='';
    if (num.toString().indexOf("-") !== -1) {
        sign = "-";
        num = num.toString().substr(1);
    }
    num = parseFloat(num);
    return sign+(Math.round((num + Number.EPSILON) * Math.pow(10, len)) / Math.pow(10, len)).toFixed(len);
  }
//看板用  比金额会计化多了 小数点后只保留两位
const formatCurrency = (num) => {
    num = Number(num)
    num = num.toFixed(2)
    if (num === 0) {
        return 0;
    } else if (num) {
        num = num.toString().replace(/\$|\,/g, "");
        if (num === "" || isNaN(num)) {
            return 0;
        }
        var sign = "";
        if (num.indexOf("-") !== -1) {
            sign = "-";
            num = num.substr(1);
        }
        var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
        cents = cents.length > 1 ? cents : "";
        num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
        if (cents === "") {
            if (num.length > 1 && num.substr(0, 1) === "0") {
                return 0;
            }
        } else {
            if (num.length > 1 && num.substr(0, 1) === "0") {
                return 0;
            }
        }
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
            num =
                num.substring(0, num.length - (4 * i + 3)) +
                "," +
                num.substring(num.length - (4 * i + 3));
        }
        return sign + num + cents;
    }
}

//列表过滤

const filterData=(condition, data)=> {
   return data.filter((item) => {
      return Object.keys(condition).every((key) => {
        if (condition[key] == "") {
          return true;
        }
        // 精准查询
        // else {
        //   return item[key] === condition[key];
        // }
        // 模糊查询
        // 这里是为了进行某个（或多个）条件的模糊查询做出的业务判断，key是对应的值。
        // let diff =
        //     (key === 'subCategoryNo' ||key==='subCategoryName')
        //         ? String(item[key]).toLowerCase().indexOf(String(condition[key]).trim().toLowerCase()) !== -1
        //         : String(item[key]).toLowerCase() == String(condition[key]).trim().toLowerCase()
        return String(item[key]).toLowerCase().indexOf(String(condition[key]).trim().toLowerCase()) !== -1
      });
    });
  };

export {
    numFilter,
    accMul,
    newFixed,
    formatCurrency,
    filterData
}



